export const auditInventorySummaryGridSchema = () => {
    return {
        schema: {
            model: {
                fields: {
                    sku: {
                        type: "string",
                        editable: false,
                    },
                    locationName: {
                        type: "string",
                        editable: false,
                    },
                    muLabelName: {
                        type: "string",
                        editable: false,
                    },
                    lotNumber: {
                        type: "string",
                        editable: false,
                    },
                    serialNumber: {
                        type: "string",
                        editable: false,
                    },
                    expirationDate: {
                        type: "date",
                        editable: false,
                    },
                    systemQty: {
                        type: "number",
                        editable: false,
                    },
                    allocatedQty: {
                        type: "number",
                        editable: false,
                    },
                    countedQty: {
                        type: "number",
                        editable: false,
                    },
                    variance: {
                        type: "number",
                        editable: false,
                    },
                },
            },
        },
    };
};

export type AuditInventorySummaryGridHeaders = {
    [key: number]: number;
    description: string;
}[];

export const auditResultsColumns = (auditInventorySummaryGridHeaders: AuditInventorySummaryGridHeaders) => [
    {
        field: "locationName",
        title: auditInventorySummaryGridHeaders[0].description,
        lockable: false,
        width: 100,
        wmsid: 1,
    },
    {
        field: "customerName",
        title: auditInventorySummaryGridHeaders[1].description,
        lockable: false,
        width: 100,
        wmsid: 2,
    },
    {
        field: "muLabelName",
        title: auditInventorySummaryGridHeaders[2].description,
        lockable: false,
        width: 100,
        wmsid: 3,
    },
    {
        field: "sku",
        title: auditInventorySummaryGridHeaders[3].description,
        lockable: false,
        width: 100,
        wmsid: 4,
    },
    {
        field: "systemQty",
        title: auditInventorySummaryGridHeaders[4].description,
        lockable: false,
        width: 100,
        wmsid: 5,
    },
    {
        field: "allocatedQty",
        title: auditInventorySummaryGridHeaders[5].description,
        lockable: false,
        width: 100,
        wmsid: 6,
    },
    {
        field: "countedQty",
        title: auditInventorySummaryGridHeaders[6].description,
        lockable: false,
        width: 100,
        wmsid: 7,
    },
    {
        field: "variance",
        title: auditInventorySummaryGridHeaders[7].description,
        lockable: false,
        width: 100,
        wmsid: 8,
    },
    {
        field: "lotNumber",
        title: auditInventorySummaryGridHeaders[8].description,
        lockable: false,
        width: 100,
        wmsid: 9,
    },
    {
        field: "serialNumber",
        title: auditInventorySummaryGridHeaders[9].description,
        lockable: false,
        width: 100,
        wmsid: 10,
    },
    {
        field: "expirationDate",
        title: auditInventorySummaryGridHeaders[10].description,
        lockable: false,
        width: 100,
        wmsid: 11,
    },
];
